<template>
    <div :class="{ 'sw-form-section': edit }">
        <div v-if="edit" class="sw-mb-1">
            <i @click="$emit('delete')" class="fa fa-trash sw-pointer sw-mr-half"></i>
            <i @click="$emit('edit')" class="fa fa-pen sw-pointer"></i>
        </div>
        <div>
            <div class="sw-index sw-flex sw-container sw-mb-1">
                {{ title }}
            </div>
            <div class="sw-scala sw-container">
                <div v-for="(answer, index) in answers" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">
                    <input
                        :value="answer.value"
                        @input="$emit('input:checked', {id: id, value: $event.target.value})"
                        :required="requiredInput"
                        :class="['sw-checkbox form-checkbox sw-mr-1', { required: requiredInput }]"
                        type="checkbox"
                        :name="id"/>
                    <div> {{ answer.text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Checkbox",
    props: {
        edit: Boolean,
        component: Object,
        id: {
            type: [String, Number],
            required: true
        },
        title: {
            type: String,
            default: 'Titel'
        },
        answers: {
            type: Array,
            required: true
        },
        answersCount: {
            type: [String, Number],
            default: 5
        }
    },
    data() {
        return{
            windowWidth:window.innerWidth
        }
    },
    mounted() {
        window.onresize =()=>{
            this.windowWidth = window.innerWidth;
        };
    },
    computed: {
        isHidden() {
            return this.component?.settings?.hidden === true;
        },
        requiredInput: {
            get(){
                return this.component.attributes.required === '1' || this.component.attributes.required === true;
            },
            set(value) {
                this.component.attributes.required = value;
            }
        }
    }
}
</script>

<style scoped>

</style>
